// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminFromAccess } from "../../api/auth";

function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem("access");

  // ❌ neautentificat
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // ❌ autentificat dar NU admin
  if (!isAdminFromAccess()) {
    return <Navigate to="/" replace />;
  }

  // ✅ admin OK
  return children;
}

export default ProtectedRoute;